import { Controller } from "@hotwired/stimulus"

// Toggles the inline manual-receive form on the Receiving page. The
// form is hidden by default; clicking "Enter manually" reveals it.
// Trivial show/hide — pulled into its own controller only because
// inline onclick handlers would be CSP-noisy and the form's wiring
// also auto-focuses the first input for keyboard-first users.
export default class extends Controller {
    static targets = ["form", "packingSlip"]

    toggle() {
        this._toggle(this.formTarget)
        if (this.hasPackingSlipTarget && this.packingSlipTarget.style.display !== "none") {
            this.packingSlipTarget.style.display = "none"
        }
    }

    togglePackingSlip() {
        if (!this.hasPackingSlipTarget) return
        this._toggle(this.packingSlipTarget)
        if (this.formTarget.style.display !== "none") {
            this.formTarget.style.display = "none"
        }
    }

    _toggle(el) {
        const showing = el.style.display !== "none"
        el.style.display = showing ? "none" : "block"
        if (!showing) {
            const firstInput = el.querySelector("select, input, textarea")
            if (firstInput) firstInput.focus()
        }
    }
}
